
import React, { useEffect, useState } from 'react';

import Form, { Item as FormItem, GroupItem, ColCountByScreen } from 'devextreme-react/form';

import { FormTextbox, FormDSVUploader, FormDateBox } from '../..';
import { EmailRule } from 'devextreme-react/validator';
import { getSizeQualifier } from '../../../utils/media-query';
import { FormSelectBox } from '../../utils/form-selectbox/FormSelectBox';
import { COURSES } from '../../../shared/constants';

export const CompetitionNewForm = ({ initData, onDataChanged, onFileChanged, fileType }) => {
  const [newCompetitionData, setNewCompetitionData] = useState({ ...initData });

  useEffect(() => {
    setNewCompetitionData({ ...initData });
  }, [initData]);

  const updateField = (field) => (value) => {
    const newData = { ...newCompetitionData, ...{ [field]: value } };

    onDataChanged(newData);
    setNewCompetitionData(newData);
  };

  return (
    <Form
      className='plain-styled-form'
      screenByWidth={getSizeQualifier}
    >
      <GroupItem>
        <ColCountByScreen xs={1} sm={1} md={1} lg={1} />
        <FormItem>
          <FormDSVUploader onValueChange={onFileChanged} fileType={fileType} />
        </FormItem>
      </GroupItem>

      <GroupItem caption='Manuelle Anlage'>
        <ColCountByScreen xs={1} sm={2} md={2} lg={2} />
      
        <FormItem>
          <FormTextbox
            label='Wettkampf-Name'
            value={newCompetitionData.competitionname}
            isEditing={false}
            onValueChange={updateField('competitionname')}
          />
        </FormItem>
        <FormItem>
          <FormTextbox
            label='Stadt'
            value={newCompetitionData.city}
            isEditing={false}
            onValueChange={updateField('city')}
          />
        </FormItem>
        <FormItem>
          <FormDateBox
            label='Startdatum'
            value={newCompetitionData.startdate}
            readOnly={false}
       
            onValueChange={updateField('startdate')}
          />
        </FormItem>
        <FormItem>
          <FormDateBox
            label='Enddatum'
            value={newCompetitionData.enddate}
            readOnly={false}
 
            onValueChange={updateField('enddate')}
          />
        </FormItem>
        <FormItem>
          <FormSelectBox
            label='Bahnlänge'
            width='100%'
            value={newCompetitionData.course}
            readOnly={false}
            dataSource={COURSES}
            onValueChange={updateField('course')}
          />

        </FormItem>
        <FormItem>
          <FormDateBox
            label='Meldeschluss'
            value={newCompetitionData.deadline}
            readOnly={false}
          
            allowClear={false}
            onValueChange={updateField('deadline')}
          />
        </FormItem>
      </GroupItem>

 
    </Form>
  );
};
